export const ENDPOINT = {
    MASTER_LOGIN: "/auth/login",
    HOSPITAL: "/hospital",
    PATIENT: "/patient",
    NURSE: "/nurses",
    PATIENT_DETAILS: "/hospital/patients_details_testlist",
    PATIENT_RECORD: "/footform/",
    FEEDBACK: "/feedback",
    DOCTOR_COMMENTS: "/doctorcomments",
    NURSE_ACTIVATE_DEACTIVATE: "/nurses/activate_deactivate",
    HOSPITAL_ACTIVATE_DEACTIVATE: "/hospital/activate_deactivate",
    DASHBOARD_DATA: "master_admin_dashbord/dashboard_data",
    DASHBOARD_ALLTEST : "/master_admin_dashbord/all_test",
    DASHBOARD_REJECTEDTEST : "/master_admin_dashbord/rejected_test",
    DASHBOARD_REFERREDTEST : "/master_admin_dashbord/hospital_data",
    PATIENT_REFERRED_LIST : "/master_admin_dashbord/patients_referred_to_hospital",
    NURSE_DETAILS: "/master_admin_dashbord/nurse_detail_data",
    NURSE_DETAILS_FILTER: "/master_admin_dashbord/nurse_detail_data_filter",
}